import React from 'react';
import './Footer.css';
import logo from '../../assets/kkp-logo.png'; // Assuming the same logo file

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-hub">
            <img alt="KKP Trade LTD" className="footer-logo" src={logo} />
            <p className="footer-pitch">
              KKP Trade LTD—your bulk deal HQ since 2025. Stacking pallets, slashing prices, and shipping nationwide from Watford’s heart.
            </p>
          </div>
          <div className="footer-contacts">
            <h4>Contact Us</h4>
            <div className="contact-item">
              <span className="contact-label">Call Us</span>
              <a href="tel:+447432496113" className="contact-info">07432 496113</a>
            </div>
            <div className="contact-item">
              <span className="contact-label">Email Us</span>
              <a href="mailto:kkptradeltd@gmail.com" className="contact-info">kkptradeltd@gmail.com</a>
            </div>
            <div className="contact-item">
              <span className="contact-label">Find Us</span>
              <span className="contact-info">317-319 Lower High St, Watford, WD17 2JD</span>
            </div>
          </div>
          <div className="footer-nav">
            <h4>Explore</h4>
            <a href="#shop" className="nav-link">Bulk Haul</a>
            <a href="#about" className="nav-link">Our Story</a>
            <a href="#support" className="nav-link">Get Help</a>
          </div>
        </div>
        <div className="footer-line">
          <p className="footer-signoff">© 2025 KKP Trade LTD. Built for the trade.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;